import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  Pagination
} from "@mui/material";
import { Tabs, } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { components } from "react-select";
// import { IoIosArrowDown } from "react-icons/io";
// import { LuLayoutDashboard } from "react-icons/lu";
import CategoryListCard from "./CategoryListCard";
import PriceFilterCard from "./PriceFilterCard";
import TrendingListCard from "./TrendingListCard";
import ProductCard from './ProductCard';
import "./PopularProduct.css";
// import product1 from '../assests/product1.png';
// import product2 from '../assests/product2.png';
// import product3 from '../assests/product3.png';
import DropDown from "./DropDown";
import showIcon from "../assests/showIcon.png";
import filterIcon from "../assests/filterIcon.png";
import { useProductStore } from "../store/useProductStore";
import { useNavigate } from "react-router-dom";
import Loader from "./Loader/Loader";
import { useCategoryStore } from "../store/useCategoryStore";
// import DropDown from "./DropDown";

const selectOptions = [
  { value: "50", label: "Show 50" },
  { value: "20", label: "Show 20" }
];
const selectOptions2 = [
  { value: "sort by featured", label: "Sort by Featured" },
  { value: "equipment", label: "Equipment" },
  { value: "pharmacy", label: "Pharmacy" }
];

const CustomOption = (props) => (
  <components.Option {...props} className="rangefilter-option">
    {props.data.label}
  </components.Option>
);

const ShopSection = () => {

  // for tabs
  const navigate = useNavigate()
  const [tabIndex, setTabIndex] = useState(0);
  const { product, loading, getAllProduct, reload, setReload } = useProductStore()
  const { selectedCategoryName } = useCategoryStore()
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [search, setSearch] = useState('');
  const [pageSize, setPageSize] = useState(16);
  const [field, setField] = useState('');
  // dropdown 
  const [selectedValue, setSelectedValue] = useState(selectOptions[0]);

  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const handleGetDetailProduct = (id) => {
    navigate(`/product-details/${id}`);
  }

  const handleChangePagination = (event, value) => {
    setPageNumber(value);
  };

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <img src={showIcon} alt="icon" />
      {children}
    </components.SingleValue>
  );
  // filter 
  const [selectedValue2, setSelectedValue2] = useState(selectOptions2[0]);
  const handleChange2 = (value) => {
    setSelectedValue2(value);
  };
  const SingleValue2 = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <img src={filterIcon} alt="icon" />
      {children}
    </components.SingleValue>
  );

  useEffect(() => {
    const fetchData = async () => {
      if (reload) {
        const data = await getAllProduct(pageNumber, pageSize, search, field);
        if (data) {
          setTotalPages(data?.totalPages)
        }
      }
      else {
        setReload(true)
      }
    };
    fetchData();
  }, [pageNumber, search, field]);
  // dropdown 
  return (
    <Box sx={{ padding: "40px 0 60px" }}>
      <Loader loading={loading} />
      <Container maxWidth="xl">
        <Grid
          container
          sx={{ width: "100%" }}
          columnSpacing={{ xs: 1, sm: 2, md: 4 }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 9 }}>
            <Tabs
              selectedIndex={tabIndex}
              onSelect={(index) => setTabIndex(index)}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "50px",
                }}
              >
                {/* <Typography className="titleSec" sx={{}}>
                  {`We Found ${product?.length || 0} Items for You`}
                </Typography> */}
                <div>
                  <Typography sx={{
                    fontSize: '24px',
                    lineHeight: '38.4px',
                    fontWeight: '700',
                    fontFamily: `"Quicksand", sans-serif`,
                    color: '#253D4E',
                  }}>
                    {`${selectedCategoryName} Products`}
                  </Typography>
                </div>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "12px",
                  }}
                >
                  {/* <DropDown
                    selectedValue={selectedValue}
                    selectOptions={selectOptions}
                    CustomOption={CustomOption}
                    handleChange={handleChange}
                    SingleValue={SingleValue}
                  />
                  <DropDown
                    selectedValue={selectedValue2}
                    selectOptions={selectOptions2}
                    CustomOption={CustomOption}
                    handleChange={handleChange2}
                    SingleValue={SingleValue2}
                  /> */}
                </Box>
              </Box>
              <Grid container spacing={2} >
                {(product || []).map((productDetail, index) => (
                  <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3 }} onClick={() => handleGetDetailProduct(productDetail?._id)}>
                    <ProductCard key={index} productDetail={productDetail} />
                  </Grid>
                ))}
              </Grid>
              
            </Tabs>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 3 }}>
            {/* <CategoryListCard /> */}
            <Box
              sx={{
                marginBottom: "30px",
              }}
            >
              <PriceFilterCard />
            </Box>
            <TrendingListCard />
          </Grid>
        </Grid>
        <Box sx={{
          "& ul":{
          display:"flex", justifyContent:"center"
        },
        "& ul li button.Mui-selected":{
          color:"#1976d2",
          backgroundColor:"#D7EDFF",
        }}}>
                <Stack spacing={2} className="flex items-center mt-8"
                 sx={{width:"100%", marginTop:"30px"}}>
                  <Pagination
                    count={totalPages}
                    onChange={handleChangePagination}
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              </Box>
      </Container>
    </Box>
  );
}

export default ShopSection;
